/**
 * 园区数据里的「省份」文案 → 民政部省级 adcode（与 DataV areas_v3 一致）
 */

import type { Park } from '../../types';

const PROVINCE_NAME_TO_ADCODE: Record<string, string> = {
  北京市: '110000',
  天津市: '120000',
  河北省: '130000',
  山西省: '140000',
  内蒙古自治区: '150000',
  内蒙古: '150000',
  辽宁省: '210000',
  吉林省: '220000',
  黑龙江省: '230000',
  上海市: '310000',
  江苏省: '320000',
  浙江省: '330000',
  安徽省: '340000',
  福建省: '350000',
  江西省: '360000',
  山东省: '370000',
  河南省: '410000',
  湖北省: '420000',
  湖南省: '430000',
  广东省: '440000',
  广西壮族自治区: '450000',
  广西省: '450000',
  广西: '450000',
  海南省: '460000',
  重庆市: '500000',
  四川省: '510000',
  贵州省: '520000',
  云南省: '530000',
  西藏自治区: '540000',
  西藏: '540000',
  陕西省: '610000',
  甘肃省: '620000',
  青海省: '630000',
  宁夏回族自治区: '640000',
  宁夏: '640000',
  新疆维吾尔自治区: '650000',
  新疆: '650000',
  台湾省: '710000',
  香港特别行政区: '810000',
  香港: '810000',
  澳门特别行政区: '820000',
  澳门: '820000',
};

export function resolveProvinceAdcode(provinceRaw: string): string | null {
  const k = provinceRaw.trim();
  return PROVINCE_NAME_TO_ADCODE[k] ?? null;
}

/**
 * 省级 adcode → GeoJSON / ECharts 地图中的省级 `properties.name`（与 DataV 一致，取同 adcode 下最长名称）
 */
export function provinceAdcodeToGeoName(adcode: string): string | null {
  const code = adcode.trim();
  const names = Object.entries(PROVINCE_NAME_TO_ADCODE)
    .filter(([, v]) => v === code)
    .map(([k]) => k);
  if (!names.length) {
    return null;
  }
  return names.reduce((a, b) => (b.length > a.length ? b : a));
}

export function sameProvinceRegion(a: string, b: string): boolean {
  const ca = resolveProvinceAdcode(a);
  const cb = resolveProvinceAdcode(b);
  return ca != null && ca === cb;
}

/** 地图地名 / 园区 CSV 省份字段 → adcode（含省/市/自治区等后缀尝试） */
export function resolveProvinceAdcodeLoose(rawName: string): string | null {
  const n = rawName.trim();
  if (!n) return null;
  const tries = [
    n,
    `${n}省`,
    `${n}市`,
    `${n}自治区`,
    `${n}特别行政区`,
    n.replace(/省$|市$|自治区$|特别行政区$/, ''),
  ];
  for (const t of tries) {
    const ad = resolveProvinceAdcode(t);
    if (ad) return ad;
  }
  return null;
}

export function parksInProvince(parks: Park[], adcode: string): Park[] {
  return parks.filter(
    (p) => resolveProvinceAdcodeLoose(p.province) === adcode,
  );
}
